mapboxgl.accessToken = window.mapboxAccessToken;

const locationHeroMap = document.querySelector('.location-hero__map-embed');

if (locationHeroMap instanceof HTMLElement) {
	const lng = parseFloat(locationHeroMap.dataset.lng || '');
	const lat = parseFloat(locationHeroMap.dataset.lat || '');

	if (!isNaN(lng) && !isNaN(lat)) {
		const map = new mapboxgl.Map({
			container: locationHeroMap,
			center: [lng, lat],
			zoom: 9,
		});

		const customMarker = locationHeroMap.querySelector('.location-hero__map-marker');
		if (customMarker instanceof HTMLElement) {
			new mapboxgl.Marker({ element: customMarker }).setLngLat([lng, lat]).addTo(map);
		}
	}
}
